<template>
  <div class="panel">
    <div class="panel-head">
      <div>
        <div class="panel-title">{{ $t('chi88') }}</div>
        <div class="subtitle">{{ $t('chi89') }}</div>
      </div>
    </div>
    <div style="overflow: auto">
      <el-table :data="pagedList" style="width: 100%" size="small" :empty-text="$t('chi9')">
        <el-table-column prop="name" :label="$t('chi90')" min-width="120"></el-table-column>
        <el-table-column prop="sn" :label="$t('chi91')" width="150"></el-table-column>
        <el-table-column prop="group_name" :label="$t('chi92')" min-width="100">
          <template slot-scope="{ row }">{{ row.group_name || '—' }}</template>
        </el-table-column>
        <el-table-column :label="$t('chi93')" width="160">
          <template slot-scope="{ row }">
            <span class="badge" :class="row.run_state > 0 ? 'online' : 'offline'">
              ● {{ row.run_state > 0 ? $t('chi71') : $t('chi72') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('chi94')" width="90">
          <template slot-scope="{ row }">{{ fmt(row.power_on_count, 0) }}</template>
        </el-table-column>
        <el-table-column :label="$t('chi95')" width="100">
          <template slot-scope="{ row }">{{ fmt(secToHours(row.runtime), 1) }} {{ $t('chi106') }}</template>
        </el-table-column>
        <el-table-column :label="$t('chi96')" width="90">
          <template slot-scope="{ row }">{{ fmt(row.avg_daily_runtime / 3600, 1) }} {{ $t('chi106') }}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-actions">
      <el-pagination
        small
        layout="prev, pager, next"
        :total="deviceList.length"
        :page-size="10"
        :current-page.sync="page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { fmt, secToHours } from "./statUtils.js";

export default {
  name: "DeviceSummaryTable",
  props: {
    // getDeviceBootLog 返回的 device_list
    deviceList: { type: Array, default: () => [] },
  },
  data() {
    return {
      page: 1,
    };
  },
  computed: {
    pagedList() {
      const start = (this.page - 1) * 10;
      return this.deviceList.slice(start, start + 10);
    },
  },
  watch: {
    // 查询条件变化导致数据更新时，回到第一页
    deviceList() {
      this.page = 1;
    },
  },
  methods: {
    fmt,
    secToHours,
  },
};
</script>

<style lang="scss" scoped>
.panel {
  background: #fff;
  border: 1px solid #dcecf4;
  border-radius: 15px;
  box-shadow: 0 8px 28px rgba(31, 142, 190, 0.08);
  overflow: hidden;
}
.panel-head {
  padding: 16px 18px;
  border-bottom: 1px solid #dcecf4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.panel-title {
  font-weight: 800;
  font-size: 16px;
  color: #314356;
}
.subtitle {
  margin-top: 5px;
  color: #7f93a6;
  font-size: 14px;
}
.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 5px 9px;
  font-size: 12px;
  font-weight: 700;
}
.online {
  background: #e9f9f2;
  color: #2faa77;
}
.offline {
  background: #fff0f0;
  color: #e85a5a;
}
.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 16px;
}
.empty {
  text-align: center;
  color: #909399;
  font-size: 14px;
  padding: 24px 0;
}
</style>
